import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsReportsNav4HomeEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(
				/* webpackChunkName: "async-assets-reports-home-entrypoint" */ './ui/assets-reports-home-page/index.tsx'
			).then((module) => module.AssetsReportsNav4HomePage);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<
			typeof import('./ui/assets-reports-home-page/index.tsx').AssetsReportsNav4HomePage
		>;
	}),
	getPreloadProps: () => ({}),
});
